import { render, staticRenderFns } from "./CreateActive.vue?vue&type=template&id=33308ad8&"
import script from "./CreateActive.vue?vue&type=script&lang=js&"
export * from "./CreateActive.vue?vue&type=script&lang=js&"
import style0 from "./CreateActive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports